import {InviteModal, Textarea} from "../../../components/Theme";
import {Button, HStack, Select, Text, VStack} from '@chakra-ui/react'
import TextLabel from "../../../components/Theme/TextLabel";
import BillingInviteModal from "../../../components/Theme/BillingInviteModal";
import httpRequest from "../../../core/services/http-request";
import {useEffect, useState} from "react";

const  BillingUsersModal = ({isOpen, onClose, company, onOpenDeleteUser,onOpenConfirmation}) => {
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState("");
    const {post} = httpRequest()
    const [loading, setLoading] = useState(false)

    console.log(company)
    const getUsers = () => {
        post('all-users-select', {
            type: "SU",
            company_id: company?.id ?? 1
        })
            .then((e) => {
                console.log(e.data.data)
                setUsers(e.data.data)
            })
            .catch(() => {})
    }
    useEffect(async () => {
       await getUsers();
    },[company])
    const confirmSu = () => {
        console.log("Gnac")
        console.log(selectedUserId)
        console.log(company)
        setLoading(true)
        post('update-billing-user', {
            company_id: company?.id,
            user_id: selectedUserId,
        })
            .then((e) => {
                console.log(11111)
                console.log(e)
                // setUsers(e.data.data)
            })
            .catch(() => {})
    }
    return (
            <BillingInviteModal
                isOpen={isOpen}
                onClose={onClose}
                bg="#8FCF74"
                title="Designate Billing User">
                <VStack py={8} maxW='518px' m='auto'>
                    <Text fontSize='3xl'>
                        Choose A User To Receive Billing Documents
                    </Text>
                    <TextLabel
                        mt={4}
                        mb={10}
                        pl='30px'
                        color='#5A5A5ADE'
                        fontFamily='Titillium Web'
                        bg='#DADADA'
                        text={company?.name}/>
                    {/*<VStack bg='#FBFBFB' border='1px solid #A9A9A9' borderRadius='6px' w='full' py={5} maxH='218px' overflow='scroll'>*/}
                    {/*    {company?.owner && <Text>{company?.owner?.firstName + ' ' + company?.owner?.lastName}</Text>}*/}
                    {/*    {company?.usersAssociated?.map((item, index) => (*/}
                    {/*        <Text key={index}>*/}
                    {/*            {item.firstName + ' ' + item.lastName}*/}
                    {/*        </Text>*/}
                    {/*    ))}*/}
                    {/*</VStack>*/}
                    <Select
                        style={{paddingLeft: "30px"}}
                        size='lg'
                        _focus=''
                        onChange={(e) => setSelectedUserId(e.target.value)}
                        _active=''
                        borderColor='#A9A9A9'
                        placeholder='Select'>
                        {company?.owner && <option value={company?.owner?.id}>{company?.owner?.firstName + company?.owner?.lastName}</option>}
                        {users?.map((item, index) => (
                            <option key={index} value={item.id}>{item?.firstName + ' ' + item?.lastName}</option>
                        ))}
                    </Select>
                    {/*<Text color='#5A5A5ADE' fontFamily='Titillium Web'>Need to <Text as='span' textDecoration='underline' cursor='pointer' onClick={onOpenDeleteUser}>sever existing user</Text> from company?</Text>*/}
                </VStack>
                <HStack pb={8} justifyContent='center'>
                    <Button onClick={onClose} height='50px' fontSize='xl' width='254px' color='black' bg='#DBDADA'>
                        Nevermind go back
                    </Button>
                    <Button height='50px' onClick={confirmSu} fontSize='xl' width='254px' color='black' bg='#8FCF74'>
                        Confirm
                    </Button>
                </HStack>
            </BillingInviteModal>
    )
}

export default BillingUsersModal